export const ShopTheLookModuleName = 'Shop The Look';
